/* The Fears — timeline scroll behaviour.

   Port of the design's _timelineInit (FundOurKids The Fears.dc.html). The
   design drives it from its DCLogic component runtime; the theme has no such
   runtime, so this runs as plain DOM code with the same numbers:

     - .tl-node toggles .tl-on through an IntersectionObserver with
       rootMargin '-42% 0px -42% 0px', so a node is lit only while it sits in
       the middle band of the viewport.
     - .tl-fill is scaled to (innerHeight * 0.55 - lineTop) / lineHeight,
       clamped to 0..1, recomputed on scroll and resize inside
       requestAnimationFrame.
     - Under prefers-reduced-motion the design skips the observer entirely:
       every node gets .tl-on and the fill jumps to scaleY(1). Ported as-is,
       so a reduced-motion visitor sees the finished rail rather than an
       empty one.

   The design also retries init up to 12 times at 200ms while its own markup
   is still mounting. Kept, because Shopify's section rendering has the same
   race in the theme editor. */
(function () {
  'use strict';

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function init(root) {
    if (root.__fokTimelineReady) return;

    var nodes = Array.prototype.slice.call(root.querySelectorAll('.fok-tlrow__node'));
    var fill = root.querySelector('.tl-fill');
    var line = root.querySelector('.tl-line');

    if (!nodes.length || !fill || !line) {
      root.__fokTlTries = (root.__fokTlTries || 0) + 1;
      if (root.__fokTlTries < 12) setTimeout(function () { init(root); }, 200);
      return;
    }
    root.__fokTimelineReady = true;

    if (reducedMotion()) {
      nodes.forEach(function (n) { n.classList.add('tl-on'); });
      fill.style.transform = 'scaleY(1)';
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        entries[i].target.classList.toggle('tl-on', entries[i].isIntersecting);
      }
    }, { rootMargin: '-42% 0px -42% 0px' });
    nodes.forEach(function (n) { io.observe(n); });

    function update() {
      var r = line.getBoundingClientRect();
      if (!r.height) return;
      var p = (window.innerHeight * 0.55 - r.top) / r.height;
      fill.style.transform = 'scaleY(' + Math.max(0, Math.min(1, p)) + ')';
    }

    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fok-timeline]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* The theme editor re-renders a section into a fresh subtree. */
  document.addEventListener('shopify:section:load', boot);
})();
